import { render } from "./CardDetailViewCanvas.vue?vue&type=template&id=0366361a&scoped=true"
import script from "./CardDetailViewCanvas.vue?vue&type=script&lang=js"
export * from "./CardDetailViewCanvas.vue?vue&type=script&lang=js"

import "./CardDetailViewCanvas.vue?vue&type=style&index=0&id=0366361a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0366361a"]])

export default __exports__